import { render, staticRenderFns } from "./OrganOop.vue?vue&type=template&id=61c974cf"
import script from "./OrganOop.vue?vue&type=script&lang=ts"
export * from "./OrganOop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports